var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-select',{attrs:{"placeholder":_vm.bottomPlaceholder,"options":_vm.options},scopedSlots:_vm._u([{key:"search",fn:function(ref){
var attributes = ref.attributes;
var events = ref.events;
return [_c('span',{staticClass:"nameSpan"},[_vm._v(_vm._s(_vm.topPlaceholder))]),_c('input',_vm._g(_vm._b({staticClass:"vs__search"},'input',attributes,false),events))]}},{key:"no-options",fn:function(ref){
var searching = ref.searching;
return [(searching)?[_vm._v(" Ничего не найдено ")]:_c('em',[_vm._v("Ничего не найдено")])]}}]),model:{value:(_vm.selectedOption),callback:function ($$v) {_vm.selectedOption=$$v},expression:"selectedOption"}})}
var staticRenderFns = []

export { render, staticRenderFns }